export default __webpack_public_path__ + "static/media/3.c1c8109f.jpg";